"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useAtomValue } from "jotai";
import { ShoppingCart } from "lucide-react";
import { Badge } from "@repo/ui/mantine";
import { cartHasCheckoutWarningAtom } from "@/app/atoms/cartHasCheckoutWarning";
import { cartItemCountAtom } from "@/app/atoms/cartItemCount";
import { sendDiscoveryEventBeacon } from "@/lib/discoveryEventBeacon";
import styles from "./CartIcon.module.css";
const CHECKOUT_WARNING_TITLE = "There is a problem with your cart";

/**
 * Header cart icon that tracks `cart_icon_clicked` on click.
 */
export function CartIcon() {
  const $ = _c(12);
  const itemCount = useAtomValue(cartItemCountAtom);
  const hasCheckoutWarning = useAtomValue(cartHasCheckoutWarningAtom);
  const countLabel = itemCount > 0 ? `${itemCount} ${itemCount === 1 ? "item" : "items"}` : null;
  const t0 = hasCheckoutWarning ? CHECKOUT_WARNING_TITLE : null;
  let t1;
  if ($[0] !== countLabel || $[1] !== t0) {
    t1 = ["Cart", countLabel, t0].filter(Boolean);
    $[0] = countLabel;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const ariaLabel = t1.join(", ");
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ShoppingCart size={24} strokeWidth={1.5} aria-hidden={true} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasCheckoutWarning || $[5] !== itemCount) {
    t3 = hasCheckoutWarning ? <Badge classNames={{
      root: styles.warningBadge
    }} size="sm" radius="xl" circle={true} title={CHECKOUT_WARNING_TITLE} aria-hidden={true}>!</Badge> : itemCount > 0 && <Badge classNames={{
      root: styles.badge
    }} size="sm" radius="xl" circle={itemCount < 10}>{itemCount}</Badge>;
    $[4] = hasCheckoutWarning;
    $[5] = itemCount;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className={styles.iconWrap}>{t2}{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== ariaLabel || $[10] !== t4) {
    t5 = <Link href="/cart" className={styles.cartButton} aria-label={ariaLabel} onClick={_temp}>{t4}</Link>;
    $[9] = ariaLabel;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp() {
  return sendDiscoveryEventBeacon("cart_icon_clicked");
}